import { SCHEDULE_SESSION_DISPLAY_TYPE_ROUND } from "../constants";

export function isSessionRound(session) {
    return session.display_type == SCHEDULE_SESSION_DISPLAY_TYPE_ROUND;
}